import { InputTypes } from "../InputTypes";
import { OptionsSources } from "../OptionsSources";

export const Aliment = Object.freeze({
  _id: {
    visibleName: "Id",
    hidden: true,
    type: InputTypes.TEXT,
  },
  food_name: {
    visibleName: "Nombre",
    type: InputTypes.COMPOSED,
    composedElements: {
      nameES: {
        visibleName: "Nombre (Español)",
        parent: "food_name",
        type: InputTypes.TEXT,
      },
      nameEN: {
        visibleName: "Nombre (Inglés)",
        parent: "food_name",
        type: InputTypes.TEXT,
      },
      nameFR: {
        visibleName: "Nombre (Francés)",
        parent: "food_name",
        type: InputTypes.TEXT,
      },
    },
  },
  /*nameES:
        {
            visibleName: "Nombre (Español)",
            parent: "food_name",
            type: InputTypes.TEXT
        },
    nameEN:
        {
            visibleName: "Nombre (Inglés)",
            parent: "food_name",
            type: InputTypes.TEXT
        },
    nameFR: {
        visibleName: "Nombre (Francés)",
        parent: "food_name",
        type: InputTypes.TEXT
    },*/
  food_type: {
    visibleName: "Tipo de alimento",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  suited_meal: {
    visibleName: "Comida adecuada",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  season: {
    visibleName: "Temporada",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  kcal: {
    visibleName: "Kilocalorías",
    type: InputTypes.NUMBER,
    units: "kcal/100g",
  },
  net_weight: {
    visibleName: "Peso neto",
    type: InputTypes.NUMBER,
  },
  home_quantity: {
    visibleName: "Unidad casera",
    type: InputTypes.NUMBER,
  },
  home_measure: {
    visibleName: "Medida casera",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  co2: {
    visibleName: "Emisiones de CO2",
    type: InputTypes.NUMBER,
  },
  avoid_diet_pref: {
    visibleName: "Dietas incompatibles según preferencias",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  avoid_diet_cond: {
    visibleName: "Dietas incompatibles según patologías",
    type: InputTypes.MULTIPLE_SELECT,
    optionsMapping: {
      source: OptionsSources.LEGEND,
    },
  },
  workout_meal: {
    visibleName: "Preentrenamiento",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  workout_exclusive: {
    visibleName: "Exclusivo de entrenamiento",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  intraworkout_exclusive: {
    visibleName: "Exclusivo de Intra-Entrenamiento",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  avoid_preworkout: {
    visibleName: "Evitar en preentrenamiento",
    type: InputTypes.SELECT,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  rep_food: {
    visibleName: "Alimento de Repetición",
    type: InputTypes.SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.BOOLEAN,
    },
  },
  unit_weight: {
    visibleName: "Unidad del alimento",
    type: InputTypes.SELECT,
    hidden: true,
    optionsMapping: {
      source: OptionsSources.INLINE,
      options: [
        { value: "g", label: "g" },
        { value: "ml", label: "ml" },
      ],
    },
  },
  h2O: {
    visibleName: "Agua",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  proteins: {
    visibleName: "Proteínas",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fat: {
    visibleName: "Grasas",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fat_SFAs: {
    visibleName: "Grasas Saturadas",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fat_MUFA: {
    visibleName: "Grasas Monoinsaturadas",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fat_PUFA: {
    visibleName: "Grasas Polinsaturadas",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fat_cholest: {
    visibleName: "Colesterol",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fat_omg3: {
    visibleName: "Omega 3",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fat_omg6: {
    visibleName: "Omega 6",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  carbohidrates: {
    visibleName: "Carbohidratos",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  ch_simple: {
    visibleName: "Carbohidratos Simples",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  ch_starch: {
    visibleName: "Almidón",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fiber: {
    visibleName: "Fibra",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fib_soluble: {
    visibleName: "Fibra Soluble",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  fib_insoluble: {
    visibleName: "Fibra Insoluble",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  a_vitam: {
    visibleName: "A",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  a1_vitam: {
    visibleName: "A1",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  b1_vitam: {
    visibleName: "B1",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  b2_vitam: {
    visibleName: "B2",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  b3_vitam: {
    visibleName: "B3",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  b5_vitam: {
    visibleName: "B5",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  b6_vitam: {
    visibleName: "B6",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  b7_vitam: {
    visibleName: "B7",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  b9_vitam: {
    visibleName: "B9",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  b12_vitam: {
    visibleName: "B12",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  c_vitam: {
    visibleName: "C",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  d_vitam: {
    visibleName: "D",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  e_vitam: {
    visibleName: "E",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  k_vitam: {
    visibleName: "K",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  carotenes: {
    visibleName: "Carótenos",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  salt: {
    visibleName: "Sal",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  calcium: {
    visibleName: "Calcio",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  iron: {
    visibleName: "Hierro",
    type: InputTypes.NUMBER,
    units: "g/100g",
  },
  iodine: {
    visibleName: "Yodo",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  magnesium: {
    visibleName: "Magnesio",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  zinc: {
    visibleName: "Zinc",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  sodium: {
    visibleName: "Sodio",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  potassium: {
    visibleName: "Potasio",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  phosphorus: {
    visibleName: "Fósforo",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  selenium: {
    visibleName: "Selenio",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  copper: {
    visibleName: "Cobre",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  chromium: {
    visibleName: "Cromo",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  nickel: {
    visibleName: "Níquel",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  chlorine: {
    visibleName: "Cloro",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  fluorine: {
    visibleName: "Flúor",
    type: InputTypes.NUMBER,
    units: "µg/100g",
  },
  manganese: {
    visibleName: "Manganeso",
    type: InputTypes.NUMBER,
    units: "mg/100g",
  },
  toString: "Aliment",
});
